// extracted by mini-css-extract-plugin
export default {"button":"ChartsToggle-module__button___FE8Mt","active":"ChartsToggle-module__active___Opxyn"};